import { render } from "./EmerdRecordList.vue?vue&type=template&id=fff05dd0"
import script from "./EmerdRecordList.vue?vue&type=script&lang=js"
export * from "./EmerdRecordList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__